var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Icon, Link, Stack, useTheme } from "@fluentui/react";
import React, { useContext, useEffect } from "react";
import { Measures } from "../../../telemetry/Measures";
import { dashboard } from "../../../telemetry/TraceLogging";
import { CtaSettingContext } from "../../contexts/CtaSettingContext";
import { getResources } from "../../getResources";
import { fireFeedbackClickEvent, getFeedbackUrl } from "../../utils/feedbackUrlUtilies";
import { WidgetPickerInteraction } from "../../utils/widgetDialogUtilities";
import { Modal } from "../generic/Modal/Modal";
import { Text } from "../generic/Text/Text";
import { WidgetPicker } from "./WidgetPicker/WidgetPicker";
import { getBulletIconStyle, getLinkStyle, getMainStackStyle, getSettingsDialogModalStyle, } from "./WidgetPickerDialog.styles";
import { DispatchOnly } from "../../../telemetry/DispatchOnly";
// The WidgetPickerDialog component implements the modal settings dialog that is home to the Widget Picker and links for 'find more widgets' and feedback.
const WidgetPickerDialog = React.memo((_a) => {
    var _b;
    var { isOpen, showArgs, onDismiss } = _a, props = __rest(_a, ["isOpen", "showArgs", "onDismiss"]);
    const theme = useTheme();
    const ctaSettingContext = useContext(CtaSettingContext);
    const urlParams = new URLSearchParams(window.location.search);
    const region = ((_b = urlParams.get("region")) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || undefined;
    useEffect(() => {
        Measures.logEvent(dashboard, "WidgetPickerShownOrHidden", 16777216 /* productAndServicePerformance */, {
            isInCtaRegion: ctaSettingContext.isInCtaRegion,
            isMeteredConnectionAllowed: ctaSettingContext.isMeteredConnectionUsageAllowed,
            isShown: isOpen,
            region: region,
        });
    }, [isOpen]);
    useEffect(() => {
        // TODO: Parse show args and do something
        // const args = new URLSearchParams(showArgs);
    }, [showArgs]);
    function onLinkInvoked(href, interaction) {
        window.location.href = href;
        widgetPickerInteracted(interaction, href);
    }
    function widgetPickerInteracted(interaction, href = "") {
        // Does not have an added widget/appId/providerId but using the same Picker event
        let partCPayload = {
            addedWidgetDefinitionId: "",
            addedWidgetPickerItemIndex: null,
            appId: "",
            change: interaction,
            isDynamicFeedEnabled: true,
            link: href,
            providerId: "",
        };
        Measures.logEvent(dashboard, "WidgetPickerInteracted", 33554432 /* productAndServiceUsage */, partCPayload);
        // Share with WebXT
        DispatchOnly.logEvent(dashboard, "WidgetPickerInteracted", 1 /* diagnosticData */, 33554432 /* productAndServiceUsage */, partCPayload);
    }
    return (React.createElement(Modal, Object.assign({}, props, { id: "widgetpicker-dialog", isOpen: isOpen, onDismiss: onDismiss, content: React.createElement(Stack, { styles: getMainStackStyle() },
            React.createElement(Text, { variant: "xLarge", textAlign: "left" }, getResources().SettingsDialog_AddWidgetsTitleText),
            React.createElement(Text, { variant: "small", textAlign: "left", color: theme.customSemanticColors.textSecondary, marginBottom: "28px" }, getResources().SettingsDialog_AddWidgetsDescriptionText),
            React.createElement(WidgetPicker, { onDismiss: onDismiss }),
            React.createElement(Stack, { verticalFill: true }),
            React.createElement(Stack, { horizontal: true, horizontalAlign: "space-between" },
                React.createElement(Text, { variant: "small", textAlign: "left" },
                    React.createElement(Link, { role: "link", target: "_blank", onClick: () => {
                            onLinkInvoked("ms-windows-store://collection/?collectionid=MerchandiserContent/Apps/WidgetCollection/Widgetsforeverything", WidgetPickerInteraction.FindMoreWidgets);
                        } }, getResources().SettingsDialog_StoreCollectionLinkText)),
                React.createElement(Text, { variant: "small", textAlign: "right" },
                    React.createElement(Link, { role: "link", target: "_blank", onClick: () => {
                            onLinkInvoked("https://go.microsoft.com/fwlink/?linkid=2161869", WidgetPickerInteraction.LearnMore);
                        }, styles: getLinkStyle() }, getResources().SettingsDialog_LearnMoreLinkText),
                    " ",
                    React.createElement(Icon, { iconName: "RadioBullet", styles: getBulletIconStyle(theme) }),
                    " ",
                    React.createElement(Link, { role: "link", target: "_blank", onClick: () => {
                            const feedbackUrl = getFeedbackUrl();
                            onLinkInvoked(feedbackUrl, WidgetPickerInteraction.GiveFeedback);
                            fireFeedbackClickEvent();
                        } }, getResources().SettingsDialog_FeedbackLinkText)))), isBlocking: true, styles: getSettingsDialogModalStyle() })));
});
export default WidgetPickerDialog;
